import React from "react";
import { NavLink } from "react-router-dom";

import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import NotificationBell from "@/components/NotificationBell";
import LapstrTextLogo from "@/assets/Lapstr-text.png";

export default function NativeAppHeader({ account, initials, isWidgetDragging, needsAccountAttention }) {
  return (
    <header className="native-v3-header" data-hidden={isWidgetDragging ? "true" : "false"}>
      <div className="native-v3-header-inner">
        <NavLink to="/" className="native-v3-brand" aria-label="Gå till startsidan">
          <img
            src="/icons/icon-512x512.png"
            alt=""
            aria-hidden="true"
            className="native-v3-brand-mark"
          />
          <img src={LapstrTextLogo} alt="Lapstr" className="native-v3-brand-wordmark" />
        </NavLink>

        {account ? (
          <div className="native-v3-header-actions">
            <NotificationBell
              triggerClassName="native-v3-header-action"
              iconClassName="native-v3-header-action-icon"
            />
            <NavLink
              data-tutorial-target="account"
              to="/account"
              aria-label="Mina sidor"
              className={({ isActive }) => [
                "native-v3-account-link",
                isActive ? "native-v3-account-link-active" : "",
              ].filter(Boolean).join(" ")}
            >
              <span className="native-v3-account-avatar-wrap">
                <Avatar className="native-v3-account-avatar">
                  <AvatarImage
                    src={account.avatar_url || ""}
                    alt={account.display_name || account.email || "Användare"}
                  />
                  <AvatarFallback>{initials}</AvatarFallback>
                </Avatar>
                {needsAccountAttention ? (
                  <span className="native-v3-account-attention" aria-label="Kontot behöver din uppmärksamhet" />
                ) : null}
              </span>
            </NavLink>
          </div>
        ) : null}
      </div>
    </header>
  );
}
